// extracted by mini-css-extract-plugin
export default {"button":"StickyWhatsApp_button__I96Qw","icon":"StickyWhatsApp_icon__wtxXi"};